import { useEffect, useState } from 'react';
import { useAuth } from './useAuth';
import { API } from '../config/config';


export const useSeller = () => {
  const { enhancedFetch } = useAuth();
  const [sellers, setSellers] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchSellers = async () => {
      try {
        const data = await enhancedFetch(`${API.HOST}/api/v1/sellers`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json'
          }
        });

        setSellers(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchSellers().then();
  }, []);

  return { sellers, loading, error };

}
